import { useRouterState } from '@tanstack/react-router';
import { startCase } from 'lodash';
import { observer } from 'mobx-react-lite';

import { Page } from '@/design-system-v2/page';
import { Routes } from '@/types/routes';

import { useNavRailPanel } from './nav-rail.hooks';

const PAGE_TITLES: Partial<Record<string, string>> = {
  [Routes.Feed]: 'Feed',
  [Routes.Meetings]: 'Meeting Notes',
  [Routes.Journal]: 'Daily Journal',
  [Routes.Integrations]: 'Integrations',
  [Routes.Sprites]: 'Library',
  [Routes.Welcome]: 'Welcome',
  [Routes.Routines]: 'Routines',
  [Routes.Projects]: 'Projects',
  [Routes.PeopleWiki]: 'Wiki',
};

const PANEL_PAGE_TITLES: Partial<Record<string, string>> = {
  [Routes.Projects]: 'Projects',
  '/chats/all': 'Chats',
  [Routes.Routines]: 'Routines',
};

export const NavRailPageTitle = observer(() => {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const panel = useNavRailPanel();

  const panelPageTitle = PANEL_PAGE_TITLES[pathname];
  if (panelPageTitle) return <Page.Title>{panelPageTitle}</Page.Title>;
  if (panel) return null;

  const section = `/${pathname.split('/')[1]}`;
  return (
    <Page.Title>
      {PAGE_TITLES[section] ?? startCase(section.slice(1))}
    </Page.Title>
  );
});
